import React from 'react';

import ModelTypeConstants from 'constants/ModelTypeConstants';
import SelectOrCreateFileInput from 'files/components/SelectOrCreateFileInput';
import SearchInput from 'search/inputs/SearchInput';

interface MultiSelectSearchEditorProps {
  config: Array<string> | null;
  onChangeConfig: (config: Array<string>) => void;
  maxItems?: number;
  modelTypes: Array<ModelTypeConstants>;
  schemaIds?: Array<string> | null;
  schemaInterfaceIds?: Array<string> | null;
  disabled?: boolean;
}

export default function MultiSelectSearchEditor({
  config,
  onChangeConfig,
  maxItems,
  modelTypes,
  schemaIds,
  schemaInterfaceIds,
  disabled,
}: MultiSelectSearchEditorProps): JSX.Element {
  if (modelTypes.length > 0 && modelTypes.every((modelType) => modelType === ModelTypeConstants.FILE)) {
    return (
      <SelectOrCreateFileInput
        disabled={disabled}
        maxItems={maxItems}
        onRemove={(itemToRemove) => {
          onChangeConfig((config ?? []).filter((item) => item !== itemToRemove));
        }}
        onSelect={(itemToAdd) => {
          if (itemToAdd != null) {
            onChangeConfig(config == null ? itemToAdd : [...config, ...itemToAdd]);
          }
        }}
        placeholder=""
        selected={config ?? []}
      />
    );
  } else {
    return (
      <SearchInput
        autoFocus={false}
        disabled={disabled}
        disableTyping={false}
        isMulti={true}
        onRemove={(itemToRemove) => {
          onChangeConfig((config ?? []).filter((item) => item !== itemToRemove));
        }}
        onSelect={(itemToAdd) => {
          if (itemToAdd != null) {
            onChangeConfig(config == null ? [itemToAdd] : [...config, itemToAdd]);
          }
        }}
        placeholder=""
        schemaIds={schemaIds ?? undefined}
        schemaInterfaceIds={schemaInterfaceIds ?? undefined}
        selected={config ?? []}
        types={modelTypes}
      />
    );
  }
}
